import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AuthService } from 'src/app/helpers/services/auth.service';
import { LanguageService } from 'src/app/helpers/services/language.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'loyaltic-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  navElement: HTMLElement;

  isDrawerOpen: boolean;
  isLogedIn = false;
  currentPage = '';
  isCollapsed = false;
  //isLoggedIn = false;
  userId ;
  currentLang: string;
  getTranslateDefaultLang: string;
  allowedCulturesForBranding = ['da-DK', 'nb-NO'];

  constructor(private router: Router, 
    public authService: AuthService, 
    private languageService: LanguageService,
    private translate: TranslateService 
   ) {
    //this.isLoggedIn = this.authService.IsLoggedIn();
    this.userId = this.authService.getUserId();
    router.events.subscribe(e => {
      if (e instanceof NavigationEnd) {
        //console.log(e);
        this.currentPage = e.urlAfterRedirects;
      }
    });

     // Subscribe to language changes
     this.languageService.currentLang$.subscribe(lang => {
      this.currentLang = lang;
    });
  }

  ngOnInit() {
    this.getTranslateDefaultLang = this.translate.defaultLang;
    //console.log("footer " + this.translate.defaultLang);
    this.navElement = null;
    this.isDrawerOpen = false;
    if(this.authService.IsLoggedIn){
      this.isLogedIn = true;
    }
  }

  isAegBrandingCulture(): boolean {
    return this.allowedCulturesForBranding.includes(this.getTranslateDefaultLang);
  }


  onLogoutClick() {
    // this.isLoggedIn = false;
    // this.authService.resetTokens();
  }

  redirectToHome() {
    const defaultLang = this.currentLang;
    // Check if currentLang is null
    if (defaultLang === "") {
      this.router.navigate(['/']);
    } else {
      this.router.navigate([`/${defaultLang}`]);
    }
    //this.router.navigate([`/${this.currentLang}`]);
  }

}
